module.exports = "https://www.gc-pro.gnp.com.mx/eec2146fe0ce87b0a03d32a34c522061.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon-repair.svg
// module id = 976
// module chunks = 0